import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { Package } from './Package';

export class HomePackage {
  @Expose({ name: 'package_status' })
  packageStatus: boolean;

  @Expose({ name: 'direct_bonus' })
  directBonus: boolean;

  @Expose({ name: 'roi_bonus' })
  roiBonus: boolean;

  @Expose({ name: 'direct_bonus_rate' })
  directBonusRate?: string;

  @Expose({ name: 'roi_bonus_rate' })
  roiBonusRate?: string;

  @Expose({ name: 'unilevel_bonus' })
  unilevelBonus: boolean;

  @Expose({ name: 'upgrade_status' })
  upgradeStatus: boolean;

  @Expose({ name: 'autoship_status' })
  autoshipStatus: boolean;

  @Expose({ name: 'price_difference' })
  priceDifference: boolean;

  @Expose({ name: 'pv_difference' })
  pvDifference: boolean;

  @Expose({ name: 'current_package_id' })
  currentPackageId?: string;

  @Expose({ name: 'current_package_expiry' })
  @Type(() => Date)
  currentPackageExpiry?: Date;

  @Type(() => Package)
  packages: Package[];

  constructor(
    directBonus: boolean,
    roiBonus: boolean,
    directBonusRate: string | undefined,
    roiBonusRate: string | undefined,
    unilevelBonus: boolean,
    packageStatus: boolean,
    upgradeStatus: boolean,
    autoshipStatus: boolean,
    priceDifference: boolean,
    pvDifference: boolean,
    currentPackageId: string | undefined,
    currentPackageExpiry: Date | undefined,
    packages: Package[]
  ) {
    this.directBonus = directBonus;
    this.roiBonus = roiBonus;
    this.directBonusRate = directBonusRate;
    this.roiBonusRate = roiBonusRate;
    this.unilevelBonus = unilevelBonus;
    this.packageStatus = packageStatus;
    this.upgradeStatus = upgradeStatus;
    this.autoshipStatus = autoshipStatus;
    this.priceDifference = priceDifference;
    this.pvDifference = pvDifference;
    this.currentPackageId = currentPackageId;
    this.currentPackageExpiry = currentPackageExpiry;
    this.packages = packages;
  }

  static fromJson(json: Record<string, any>): HomePackage {
    return plainToInstance(HomePackage, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
